import { rgIDs } from '../../shared/constants/domIDs';
import { libHost } from '../../shared/constants/urls';
import { injectScript } from '../../shared/injectScript';
import {
  BaseCompact,
  CompactConfig,
  MAX_COMPACT_HEIGHT_DESKTOP,
  MAX_COMPACT_HEIGHT_MOBILE,
  MAX_COMPACT_HEIGHT_WITH_ACTIONS,
} from '../compact/base';
import { createFrame } from '../utils/builder';
import { IntegrationsFactory } from '../../integrations/factory';
import './styles.scss';

function hasCompactV2Actions(config: CompactConfig) {
  const platform = config.screen.isMobile ? 'mobile' : 'desktop';
  const integrations = new IntegrationsFactory(config.listing as any).create();
  const serviceData = {
    ...(integrations.knock?.services?.[platform] ?? {}),
    ...(integrations.rentgrata?.services?.[platform] ?? {}),
  };
  const platformActiveServices = [
    'schedule',
    'availability',
    'photos',
    'neighborhood',
    'requestText',
    'contact',
  ].filter((service) => Boolean(serviceData[service]));

  if (platformActiveServices.length) return true;

  const hasFallbackMoreServices = Object.values(
    integrations.knock?.services?.more ?? {}
  ).some(Boolean);
  const hasMoreIcon = Boolean(integrations[platform]?.moreIcon);

  return hasFallbackMoreServices || hasMoreIcon;
}

export class RGCompactV2 extends BaseCompact {
  constructor() {
    super(rgIDs.compactV2);
  }

  onShow() {}

  onHide() {}

  unmount() {
    super.unmount();

    if (this.element?.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
  }

  shouldRender(config) {
    return ['fixed'].includes(config?.renderAs);
  }

  render = async (config: CompactConfig): Promise<void> => {
    if (!this.shouldRender(config)) return;

    try {
      this.config = config;
      this.element = await createFrame(this.elId);
      const hasActionButtons = hasCompactV2Actions(config);

      this.setMargins();
      this.setZIndex();
      this.setHeight(hasActionButtons);

      await injectScript(`${libHost}/rg-compact-v2-init.min.js`, '');

      window.RGCompactV2Component.render(config, this.elId);

      this.setupMagnetization();
    } catch (error) {
      console.log(error);
      this.teardownMagnetization();
    }
  };

  setHeight(hasActionButtons: boolean) {
    if (this.element) {
      if (hasActionButtons) {
        this.element.style.height = `${MAX_COMPACT_HEIGHT_WITH_ACTIONS}px`;
      } else {
        this.element.style.height = this.config.screen.isMobile
          ? `${MAX_COMPACT_HEIGHT_MOBILE}px`
          : `${MAX_COMPACT_HEIGHT_DESKTOP}px`;
      }
    }
  }
}

window.RGCompactV2 = new RGCompactV2();
